module.exports = __webpack_public_path__ + "img/i1.2a239d32.png";